import styled from "styled-components";

export const DashboardWrapper = styled.section`
  margin-left: 0px;
`;
